import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/lib/auth-context';

function FullPageSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground">
      Načítám…
    </div>
  );
}

export function RequireAuth() {
  const { isLoggedIn, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (!isLoggedIn) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export function RequireAdmin() {
  const { isAdmin, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}

export function RedirectIfLoggedIn() {
  const { isLoggedIn, loading } = useAuth();
  if (loading) return <FullPageSpinner />;
  if (isLoggedIn) return <Navigate to="/dashboard" replace />;
  return <Outlet />;
}
